// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for DeviceList component
 */

.device-list {
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
}

.device-list__items {
  max-height: 400px;
  overflow-y: auto;
}

/* Device list item */
.device-list-item {
  padding: 15px 20px;
  border-bottom: 1px solid #CDCCCD;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s;
  gap: 14px;
}

.device-list-item:last-child {
  border-bottom: none;
}

.device-list-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.device-list-item--current {
  background-color: #f0f8ff;
}

.device-list-item--current:hover {
  background-color: #e6f4ff;
}

.device-list-item__info {
  flex: 1;
}

.device-list-item__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}

.device-list-item__name {
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  letter-spacing: -0.024em;
  line-height: 1.36;
}

.device-list-item__current-badge {
  font-size: 14px;
  color: #007bff;
  font-weight: normal;
  margin-left: 5px;
}

.device-list-item__details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.device-list-item__id,
.device-list-item__last-seen {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #8E8E93;
  line-height: 1.29;
}

.device-list-item__actions {
  margin-left: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Device logout button */
.device-logout-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: background-color 0.2s, color 0.2s;
  color: #DE4858;
  height: 32px;
  min-width: 60px;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.19;
}

.device-logout-button:hover {
  background-color: #c8c8c8;
  color: #DE4858;
}

.device-logout-button ion-icon {
  font-size: 20px;
  pointer-events: none;
}

.device-logout-button:active {
  background-color: #b8b8b8;
}

/* Loading state */
.device-list--loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.device-list--loading .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f0f0f0;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error state */
.device-list--error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.device-list--error .error-message {
  color: #dc3545;
  margin-bottom: 20px;
}

/* Empty state */
.device-list--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #666;
}

/* Button variations */
.btn-sm {
  padding: 6px 12px;
  font-size: 12px;
}

/* Dehydrated device styling */
.device-list-item--dehydrated {
  background-color: #fef9e7;
}

.device-list-item--dehydrated:hover {
  background-color: #fef3cd;
}

.device-list-item__dehydration-note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 8px;
  padding: 8px 10px;
  background-color: #fff8e1;
  border-radius: 6px;
  border-left: 3px solid #ffc107;
}

.device-list-item__dehydration-note ion-icon {
  font-size: 16px;
  color: #f57c00;
  flex-shrink: 0;
  margin-top: 1px;
}

.device-list-item__dehydration-note span {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #5d4037;
  line-height: 1.4;
}

/* Dark theme */
@media (prefers-color-scheme: dark) {
  .device-list {
    background: #1e1e1e;
    box-shadow: none;
  }

  .device-list-item {
    border-bottom-color: #2a2a2a;
  }

  .device-list-item:hover {
    background-color: #2a2a2a;
  }

  .device-list-item--current {
    background-color: #1a2a3a;
  }

  .device-list-item--current:hover {
    background-color: #1e3148;
  }

  .device-list-item__name {
    color: #FFFFFF;
  }

  .device-list-item__current-badge {
    color: #60a5fa;
  }

  .device-list-item__id,
  .device-list-item__last-seen {
    color: #8E8E93;
  }

  .device-list--empty {
    color: #999;
  }

  .device-logout-button {
    background-color: #3a3a3a;
    color: #DE4858;
  }

  .device-logout-button:hover {
    background-color: #4a4a4a;
    color: #DE4858;
  }

  .device-logout-button:active {
    background-color: #2a2a2a;
  }

  .device-list-item--dehydrated {
    background-color: #3d3017;
  }

  .device-list-item--dehydrated:hover {
    background-color: #4a3a1c;
  }

  .device-list-item__dehydration-note {
    background-color: #4a3a1c;
    border-left-color: #ffc107;
  }

  .device-list-item__dehydration-note span {
    color: #ffe082;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/devices/DeviceList.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;EAC7C,cAAc;EACd,YAAY;EACZ,eAAe;EACf,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/**\n * Styles for DeviceList component\n */\n\n.device-list {\n  border-radius: 0;\n  box-shadow: none;\n  overflow: hidden;\n}\n\n.device-list__items {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Device list item */\n.device-list-item {\n  padding: 15px 20px;\n  border-bottom: 1px solid #CDCCCD;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.2s;\n  gap: 14px;\n}\n\n.device-list-item:last-child {\n  border-bottom: none;\n}\n\n.device-list-item:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.device-list-item--current {\n  background-color: #f0f8ff;\n}\n\n.device-list-item--current:hover {\n  background-color: #e6f4ff;\n}\n\n.device-list-item__info {\n  flex: 1;\n}\n\n.device-list-item__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 5px;\n}\n\n.device-list-item__name {\n  margin: 0;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  color: #000000;\n  letter-spacing: -0.024em;\n  line-height: 1.36;\n}\n\n.device-list-item__current-badge {\n  font-size: 14px;\n  color: #007bff;\n  font-weight: normal;\n  margin-left: 5px;\n}\n\n.device-list-item__details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.device-list-item__id,\n.device-list-item__last-seen {\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #8E8E93;\n  line-height: 1.29;\n}\n\n.device-list-item__actions {\n  margin-left: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Device logout button */\n.device-logout-button {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0px 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: background-color 0.2s, color 0.2s;\n  color: #DE4858;\n  height: 32px;\n  min-width: 60px;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.19;\n}\n\n.device-logout-button:hover {\n  background-color: #c8c8c8;\n  color: #DE4858;\n}\n\n.device-logout-button ion-icon {\n  font-size: 20px;\n  pointer-events: none;\n}\n\n.device-logout-button:active {\n  background-color: #b8b8b8;\n}\n\n/* Loading state */\n.device-list--loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.device-list--loading .spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f0f0f0;\n  border-top: 3px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error state */\n.device-list--error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.device-list--error .error-message {\n  color: #dc3545;\n  margin-bottom: 20px;\n}\n\n/* Empty state */\n.device-list--empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  color: #666;\n}\n\n/* Button variations */\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n/* Dehydrated device styling */\n.device-list-item--dehydrated {\n  background-color: #fef9e7;\n}\n\n.device-list-item--dehydrated:hover {\n  background-color: #fef3cd;\n}\n\n.device-list-item__dehydration-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-top: 8px;\n  padding: 8px 10px;\n  background-color: #fff8e1;\n  border-radius: 6px;\n  border-left: 3px solid #ffc107;\n}\n\n.device-list-item__dehydration-note ion-icon {\n  font-size: 16px;\n  color: #f57c00;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.device-list-item__dehydration-note span {\n  font-family: 'Inter', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: #5d4037;\n  line-height: 1.4;\n}\n\n/* Dark theme */\n@media (prefers-color-scheme: dark) {\n  .device-list {\n    background: #1e1e1e;\n    box-shadow: none;\n  }\n\n  .device-list-item {\n    border-bottom-color: #2a2a2a;\n  }\n\n  .device-list-item:hover {\n    background-color: #2a2a2a;\n  }\n\n  .device-list-item--current {\n    background-color: #1a2a3a;\n  }\n\n  .device-list-item--current:hover {\n    background-color: #1e3148;\n  }\n\n  .device-list-item__name {\n    color: #FFFFFF;\n  }\n\n  .device-list-item__current-badge {\n    color: #60a5fa;\n  }\n\n  .device-list-item__id,\n  .device-list-item__last-seen {\n    color: #8E8E93;\n  }\n\n  .device-list--empty {\n    color: #999;\n  }\n\n  .device-logout-button {\n    background-color: #3a3a3a;\n    color: #DE4858;\n  }\n\n  .device-logout-button:hover {\n    background-color: #4a4a4a;\n    color: #DE4858;\n  }\n\n  .device-logout-button:active {\n    background-color: #2a2a2a;\n  }\n\n  .device-list-item--dehydrated {\n    background-color: #3d3017;\n  }\n\n  .device-list-item--dehydrated:hover {\n    background-color: #4a3a1c;\n  }\n\n  .device-list-item__dehydration-note {\n    background-color: #4a3a1c;\n    border-left-color: #ffc107;\n  }\n\n  .device-list-item__dehydration-note span {\n    color: #ffe082;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
